import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRoute, ROUTE_ENUMS } from '../../helpers/routes';
import {
	Box,
	Container,
	Button,
	Grid,
	IconButton,
	// ListItemButton,
	// ListItemText,
	Drawer
} from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import Branding from '../Branding/Branding';

const HeaderLanding = () => {
	const [isMobile, setIsMobile] = useState(false);
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth < 1200);
		handleResize();
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

	const closeMenu = () => setIsMenuOpen(false);

	// const navLinks = [
	// 	{ label: 'Home', href: '/' },
	// 	{ label: 'Privacy', href: '#trust' },
	// 	{ label: 'Features', href: '#features' }
	// ];

	return (
		<>
			<Box
				sx={{
					position: 'fixed',
					top: 0,
					left: 0,
					right: 0,
					zIndex: 1300,
					background: (theme) => theme.palette.background.default,
					borderBottom: 1,
					borderColor: (theme) => theme.palette.divider,
					padding: '10px',
					px: { xs: 2, md: 4 }
				}}
			>
				<Container
					maxWidth="lg"
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center'
					}}
				>
					<Box
						onClick={() =>
							navigate(getRoute(ROUTE_ENUMS.ROOT), { replace: true })
						}
						sx={{ cursor: 'pointer' }}
					>
						<Branding />
					</Box>

					<Box sx={{ display: { xs: 'none', md: 'flex', gap: 2 } }}>
						{/* {navLinks.map((link) => (
							<Button
								key={link.label}
								component="a"
								href={link.href}
								sx={{ textTransform: 'none', color: 'text.secondary' }}
							>
								{link.label}
							</Button>
						))} */}
						<Button
							component="a"
							href="/pricing"
							variant="outlined"
							size="small"
							sx={{ textTransform: 'none', fontWeight: 500 }}
						>
							Pricing
						</Button>
						<Button
							component="a"
							href="/login"
							variant="contained"
							sx={{ borderRadius: 2, textTransform: 'none' }}
						>
							Log In
						</Button>
					</Box>

					<IconButton
						onClick={toggleMenu}
						color="inherit"
						sx={{ display: { xs: 'block', md: 'none' } }}
					>
						{isMenuOpen ? <CloseIcon fontSize="large" /> : <MenuIcon />}
					</IconButton>
				</Container>
			</Box>

			{isMobile && isMenuOpen && (
				<Drawer anchor="bottom" sx={{ zIndex: 1299 }}>
					<Box p={2} onClick={closeMenu}>
						<Grid container spacing={1}>
							{/* {navLinks.map((link) => (
								<Grid key={link.label} item xs={12} display="block">
									<ListItemButton
										component="a"
										href={link.href}
										sx={{ justifyContent: 'flex-start', py: 2 }}
										onClick={closeMenu}
									>
										<ListItemText primary={link.label} />
									</ListItemButton>
								</Grid>
							))} */}

							<Box sx={{ mt: 2 }}>
								<Button
									component="a"
									href="/pricing"
									fullWidth
									variant="outlined"
									size="large"
								>
									Pricing
								</Button>
							</Box>

							<Box sx={{ mt: 1 }}>
								<Button
									component="a"
									href="/login"
									fullWidth
									variant="contained"
									size="large"
								>
									Log In
								</Button>
							</Box>
						</Grid>
					</Box>
				</Drawer>
			)}
		</>
	);
};

export default HeaderLanding;
